import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { sendRequestItemToAO } from '@api/assetsRent';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_RENT_REQUEST_CARD } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateSendRequestItemToAO = (id: string, onSuccessCallbacks: Array<() => void>) => {
	const dispatch = useAppDispatch();

	const { mutate: sendRequestToAO } = useMutation({
		mutationKey: [ASSET_RENT_REQUEST_CARD, id],
		mutationFn: (comment: string) => {
			return id && sendRequestItemToAO({ requestId: id, comment });
		},
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetRentProposedDatesForItemSuccess,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallbacks.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}
		},
		enabled: [id],
	});

	return {
		sendRequestToAO: sendRequestToAO as unknown as (comment: string) => void,
	};
};
